<button class="btn btn-primary" [disabled]="!isActive" (click)="buttonClick()">
    {{ 'add-schedule' | translate }}
</button>